// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3D7TM","toggleWrap":"styles_toggleWrap__1bqRg","content":"styles_content__1VM_L","selectAreaCode":"styles_selectAreaCode__3Gt4T"};